/**
 * Types of components available in the field editor
 */
export enum EditorComponentType {
  TEXT = 'text',
  NUMBER = 'number',
  OPTIONS = 'options',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  RADIO = 'radio',
  TEXTAREA = 'textarea',
  DATE = 'date',
  TIME = 'time',
  LABEL = 'label',
  OBJECT_ORDER_LIST = 'object-order-list',
  DEPENDENCY_SELECT = 'dependency-select',  // Dependency field selector for Yes/No fields
  EDITOR = 'editor'  // Rich text editor for instruction content
}

/**
 * Configuration for object order list editor
 */
export interface OrderListConfig {
  displayProperty: string;           // Property name to display, defaults to 'label'
  idProperty?: string;               // ID property name, defaults to 'id'
  booleanProperty?: string;          // Optional boolean property name for checkbox
  booleanLabel?: string;             // Label for boolean property, defaults to property name
  itemTemplate?: 'simple' | 'detailed'; // Template type
  allowReorder?: boolean;            // Whether to allow reordering, defaults to true
}

/**
 * Configuration for editor components
 */
export interface EditorComponent {
  type: EditorComponentType;  // Type of editor component
  key: string;               // Property key to edit
  label: string;             // Display label
  placeholder?: string;       // Placeholder text
  options?: string[] | {label: string, value: any}[]; // List of options for selection (string array or object array)
  defaultValue?: any;        // Default value for the field
  readonly?: boolean;        // Whether the field is read-only
  disabled?: boolean;        // Whether the field is disabled
  columnIndex?: 0 | 1;       // Column index for 2-column layout (0 = left, 1 = right), defaults to 0
  orderListConfig?: OrderListConfig; // Configuration for object order list editor
}
